import { FC } from 'react'

import ByFashionTechNews from '../ByFashionTechNews'
import Link from '@atoms/Link'
import ArtisanLogo from '@atoms/ArtisanLogo'
import LanguageSwitch from '@molecules/LanguageSwitch'
import Instagram from '@icons/Instagram'
import { mailToArtisan } from '@models/Util'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

const ArtisanFooter: FC = () => {
  const { locale } = useTranslation()

  return (
    <footer className={style.footer}>
      <Link to="/artisan" className={style.logo}>
        <ArtisanLogo />
      </Link>
      <Link
        to="https://www.instagram.com/ftn_artisan/"
        className={style.instagram}
      >
        <Instagram />
      </Link>
      <div className={style.links}>
        <Link to="/artisan/features" className={style.link}>
          SPECIAL FEATURE
        </Link>
        <Link to="/artisan/series" className={style.link}>
          SERIES
        </Link>
        <Link to="/artisan/articles" className={style.link}>
          LATEST ARTICLES
        </Link>
      </div>

      <div className={style.subLinks}>
        <Link to="/artisan/about" className={style.subLink}>
          <h3>ABOUT</h3>
        </Link>
        <Link to="/privacy" className={style.subLink}>
          <h3>PRIVACY POLICY</h3>
        </Link>
        <a href={mailToArtisan(locale)} className={style.subLink}>
          <h3>CONTACT</h3>
        </a>
      </div>
      <div className={style.language}>
        <LanguageSwitch />
      </div>
      <div className={style.ftn}>
        <ByFashionTechNews />
      </div>
      <div className={style.rights}>
        ©︎ZOZO NEXT, Inc. All Rights Reserved.
      </div>
    </footer>
  )
}

export default ArtisanFooter
